<template>
    <el-dialog :title="finalDialogTitle" :visible.sync="localDialogVisible" :width="dialogWidth"
        class="custom-form-dialog dialog-with-radius" :close-on-click-modal="closeOnClickModal" top="5vh"
        @close="handleDialogClose">
        <el-form ref="formRef" :model="formData" :label-width="labelWidth" :inline="inline" style="max-height: 700px;overflow: auto;"
            :label-position="labelPosition" :size="formSize" class="custom-form" :disabled="formDisabled">
            <!-- 动态渲染表单项：按行渲染 -->
            <el-row :gutter="gutter" v-for="(row, rowIndex) in formConfig" :key="rowIndex">
                <!-- 每行内的表单项：按列渲染 -->
                <el-col :span="item.span || 12" v-for="(item, itemIndex) in row" :key="itemIndex" class="form-item-col">
                    <!-- 条件显隐控制 -->
                    <template v-if="isItemShow(item)">
                        <el-form-item :label="item.label" :prop="item.prop"
                            :rules="item.rules || (item.required ? [{ required: true, message: `${item.label}不能为空`, trigger: 'blur' }] : [])"
                            :disabled="getItemDisabledStatus(item)" :label-width="item.labelWidth || labelWidth"
                            :label-position="item.labelPosition || labelPosition" :required="item.required"
                            :error="item.error" :show-message="item.showMessage !== false"
                            :inline-message="item.inlineMessage" :size="item.size || formSize">
                            <template v-if="item.type === 'custom'">
                                <slot :name="`${item.prop}-slot`" :formData="formData" :dialogType="dialogType"
                                    :item="item"></slot>
                            </template>
                            <template v-else>
                                <slot :name="`${item.prop}-slot`" :formData="formData" :dialogType="dialogType"
                                    :item="item">
                                    <!-- 1. 输入框 -->
                                    <el-input v-if="item.type === 'input'" v-model="formData[item.prop]"
                                        :type="item.inputType || 'text'"
                                        :placeholder="item.placeholder || `请输入${item.label}`"
                                        :disabled="getItemDisabledStatus(item)" :size="item.size || formSize"
                                        :maxlength="item.maxlength" :minlength="item.minlength"
                                        :show-word-limit="item.showWordLimit" :clearable="item.clearable !== false"
                                        :prefix-icon="item.prefixIcon" :suffix-icon="item.suffixIcon"
                                        :readonly="item.readonly" :autocomplete="item.autocomplete || 'off'"
                                        @input="handleItemInput(item.prop, $event)"
                                        @change="handleItemChange(item.prop, $event)"
                                        @clear="handleItemClear(item.prop)">
                                    </el-input>

                                    <!-- 2. 下拉选择器（支持自定义options key） -->
                                    <el-select v-else-if="item.type === 'select'" v-model="formData[item.prop]"
                                        :placeholder="item.placeholder || `请选择${item.label}`"
                                        :disabled="getItemDisabledStatus(item)" :size="item.size || formSize"
                                        :multiple="item.multiple" :clearable="item.clearable !== false"
                                        :filterable="item.filterable" :remote="item.remote"
                                        :remote-method="item.remoteMethod" :loading="item.loading"
                                        :collapse-tags="item.collapseTags" :multiple-limit="item.multipleLimit"
                                        :allow-create="item.allowCreate" @change="handleItemChange(item.prop, $event)"
                                        @clear="handleItemClear(item.prop)" @blur="handleItemBlur(item.prop, $event)">
                                        <el-option v-for="opt in item.options"
                                            :key="opt[getOptionValueKey(item)] || opt[getOptionLabelKey(item)]"
                                            :label="opt[getOptionLabelKey(item)]" :value="opt[getOptionValueKey(item)]"
                                            :disabled="opt[getOptionDisabledKey(item)]">
                                        </el-option>
                                    </el-select>
                                    <!-- 3. 单选框组（支持自定义options key） -->
                                    <el-radio-group v-else-if="item.type === 'radio'" v-model="formData[item.prop]"
                                        :disabled="getItemDisabledStatus(item)" :size="item.size || formSize"
                                        :text-color="item.textColor" :fill="item.fill"
                                        @change="handleItemChange(item.prop, $event)">
                                        <el-radio v-for="opt in item.options"
                                            :key="opt[getOptionValueKey(item)] || opt[getOptionLabelKey(item)]"
                                            :label="opt[getOptionValueKey(item)]"
                                            :disabled="opt[getOptionDisabledKey(item)]" :border="item.border">
                                            {{ opt[getOptionLabelKey(item)] }}
                                        </el-radio>
                                    </el-radio-group>
                                    <!-- 4. 多选框组（支持自定义options key） -->
                                    <el-checkbox-group v-else-if="item.type === 'checkbox'"
                                        v-model="formData[item.prop]" :disabled="getItemDisabledStatus(item)"
                                        :size="item.size || formSize" @change="handleItemChange(item.prop, $event)">
                                        <el-checkbox v-for="opt in item.options"
                                            :key="opt[getOptionValueKey(item)] || opt[getOptionLabelKey(item)]"
                                            :label="opt[getOptionValueKey(item)]"
                                            :disabled="opt[getOptionDisabledKey(item)]" :border="item.border"
                                            :checked="opt.checked" :indeterminate="opt.indeterminate" :min="item.min"
                                            :max="item.max">
                                            {{ opt[getOptionLabelKey(item)] }}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                    <!-- 5. 日期选择器 -->
                                    <el-date-picker v-else-if="item.type === 'date'" v-model="formData[item.prop]"
                                        :type="item.dateType || 'date'"
                                        :placeholder="item.placeholder || `请选择${item.label}`"
                                        :disabled="getItemDisabledStatus(item)" :size="item.size || formSize"
                                        :format="item.format" :value-format="item.valueFormat"
                                        :range-separator="item.rangeSeparator || '至'"
                                        :start-placeholder="item.startPlaceholder"
                                        :end-placeholder="item.endPlaceholder" :disabled-date="item.disabledDate"
                                        :editable="item.editable !== false" :clearable="item.clearable !== false"
                                        :readonly="item.readonly" :unlink-panels="item.unlinkPanels"
                                        :prefix-icon="item.prefixIcon" :clear-icon="item.clearIcon"
                                        :validate-event="item.validateEvent !== false"
                                        @change="handleItemChange(item.prop, $event)"
                                        @blur="handleItemBlur(item.prop, $event)" @clear="handleItemClear(item.prop)">
                                    </el-date-picker>
                                    <!-- 6. 时间选择器 -->
                                    <el-time-picker v-else-if="item.type === 'time'" v-model="formData[item.prop]"
                                        :placeholder="item.placeholder || `请选择${item.label}`"
                                        :disabled="getItemDisabledStatus(item)" :size="item.size || formSize"
                                        :format="item.format || 'HH:mm:ss'" :value-format="item.valueFormat"
                                        :range-separator="item.rangeSeparator || '至'"
                                        :start-placeholder="item.startPlaceholder"
                                        :end-placeholder="item.endPlaceholder" :disabled-hours="item.disabledHours"
                                        :disabled-minutes="item.disabledMinutes"
                                        :disabled-seconds="item.disabledSeconds" :editable="item.editable !== false"
                                        :clearable="item.clearable !== false" :readonly="item.readonly"
                                        :is-range="item.isRange" :arrow-control="item.arrowControl"
                                        @change="handleItemChange(item.prop, $event)"
                                        @blur="handleItemBlur(item.prop, $event)" @clear="handleItemClear(item.prop)">
                                    </el-time-picker>

                                    <!-- 7. 文本域 -->
                                    <el-input v-else-if="item.type === 'textarea'" v-model="formData[item.prop]"
                                        type="textarea" :rows="item.rows || 4"
                                        :placeholder="item.placeholder || `请输入${item.label}`"
                                        :disabled="getItemDisabledStatus(item)" :size="item.size || formSize"
                                        :maxlength="item.maxlength" :minlength="item.minlength"
                                        :show-word-limit="item.showWordLimit" :readonly="item.readonly"
                                        :autosize="item.autosize" @input="handleItemInput(item.prop, $event)"
                                        @change="handleItemChange(item.prop, $event)">
                                    </el-input>

                                    <!-- 8. 文件上传组件 -->
                                    <upload-only v-else-if="item.type === 'upload'" :ref="`uploadRef_${item.prop}`"
                                        :multiple="item.multiple !== false" :accept-type="item.acceptType || ''"
                                        :limit="item.limit || Infinity"
                                        :historyFiles="formData[item.prop] ? formatUploadHistoryFiles(item, formData[item.prop]) : []"
                                        @upload-success="(files) => handleUploadSuccess(item, files)"
                                        :disabled="getItemDisabledStatus(item)">
                                        <template #upload-btn>
                                            <el-button type="primary" icon="el-icon-upload"
                                                :size="item.size || formSize" :disabled="getItemDisabledStatus(item)">
                                                {{ item.uploadBtnText || '选择文件' }}
                                            </el-button>
                                        </template>
                                    </upload-only>
                                </slot>
                            </template>
                            <!-- 自定义表单项插槽：优先级最高 -->
                        </el-form-item>
                    </template>
                </el-col>
            </el-row>
        </el-form>
        <!-- 弹窗底部按钮 -->
        <template #footer>
            <el-button :size="formSize" class="dialog-footer-btn cancel-btn" @click="handleCancel">
                {{ cancelText || '取消' }}
            </el-button>
            <el-button type="primary" :size="formSize" class="dialog-footer-btn confirm-btn" @click="handleConfirm">
                {{ confirmText || (dialogType === 'add' ? '确认新增' : '确认编辑') }}
            </el-button>
        </template>
    </el-dialog>
</template>

<script>
import uploadOnly from '../myUpload/ajUpload.vue'

export default {
    name: "BaseFormDialog",
    components: {
        uploadOnly
    },
    props: {
        // 表单项行间距
        gutter: {
            type: Number,
            default: 20
        },
        // 弹窗类型：add-新增，edit-编辑（必传）
        dialogType: {
            type: String,
            required: true,
            validator: val => ['add', 'edit'].includes(val)
        },
        // 表单配置（核心，必传）
        formConfig: {
            type: Array,
            required: true
        },
        // 表单绑定数据（必传）
        formData: {
            type: Object,
            required: true
        },
        // 弹窗显隐状态（必传，需加.sync）
        dialogVisible: {
            type: Boolean,
            required: true
        },
        // 弹窗标题
        dialogTitle: {
            type: String,
            default: ''
        },
        // 弹窗宽度
        dialogWidth: {
            type: [String, Number],
            default: '500px'
        },
        // 是否点击遮罩层关闭弹窗
        closeOnClickModal: {
            type: Boolean,
            default: false
        },
        // 表单标签宽度
        labelWidth: {
            type: [String, Number],
            default: '80px'
        },
        // 表单标签位置
        labelPosition: {
            type: String,
            default: 'right',
            validator: val => ['left', 'right', 'top'].includes(val)
        },
        // 是否行内表单
        inline: {
            type: Boolean,
            default: false
        },
        // 表单尺寸
        formSize: {
            type: String,
            default: 'medium',
            validator: val => ['large', 'medium', 'small', 'mini'].includes(val)
        },
        // 是否整体禁用表单
        formDisabled: {
            type: Boolean,
            default: false
        },
        // 取消按钮文字
        cancelText: {
            type: String,
            default: ''
        },
        // 确认按钮文字
        confirmText: {
            type: String,
            default: ''
        },
        // 规则变化时是否重新校验
        validateOnRuleChange: {
            type: Boolean,
            default: true
        },
        // ========== 新增：自定义Options Key 全局配置 ==========
        // 全局options标签字段名
        optionLabelKey: {
            type: String,
            default: 'label'
        },
        // 全局options值字段名
        optionValueKey: {
            type: String,
            default: 'value'
        },
        // 全局options禁用状态字段名
        optionDisabledKey: {
            type: String,
            default: 'disabled'
        }
    },
    data() {
        return {
            // 弹窗显隐状态本地缓存（解决.sync双向绑定问题）
            localDialogVisible: this.dialogVisible
        };
    },
    watch: {
        // 监听外部弹窗状态变化，同步到本地
        dialogVisible(newVal) {
            this.localDialogVisible = newVal;
        }
    },
    computed: {
        // 最终弹窗标题（优先使用自定义标题，否则按类型自动生成）
        finalDialogTitle() {
            return this.dialogTitle || (this.dialogType === 'add' ? '新增数据' : '编辑数据');
        }
    },
    methods: {
        // ========== 新增：获取自定义Options Key（局部优先，全局次之，默认兜底） ==========
        /**
         * 获取表单项的options标签字段名
         * @param {Object} item 表单项配置
         * @returns {String} 标签字段名
         */
        getOptionLabelKey(item) {
            return item.optionLabelKey || this.optionLabelKey || 'label';
        },
        /**
         * 获取表单项的options值字段名
         * @param {Object} item 表单项配置
         * @returns {String} 值字段名
         */
        getOptionValueKey(item) {
            return item.optionValueKey || this.optionValueKey || 'value';
        },
        /**
         * 获取表单项的options禁用状态字段名
         * @param {Object} item 表单项配置
         * @returns {String} 禁用状态字段名
         */
        getOptionDisabledKey(item) {
            return item.optionDisabledKey || this.optionDisabledKey || 'disabled';
        },

        /**
         * 重置所有上传组件状态
         */
        resetAllUploadComponents() {
            // 1. 遍历表单配置，找到所有上传类型的表单项
            const uploadProps = [];
            this.formConfig.forEach(row => {
                row.forEach(item => {
                    if (item.type === 'upload') {
                        uploadProps.push(item.prop);
                    }
                });
            });

            // 2. 重置每个上传组件
            uploadProps.forEach(prop => {
                const uploadRef = this.$refs[`uploadRef_${prop}`];
                if (uploadRef) {
                    // 兼容数组形式的ref（Vue循环渲染）
                    const uploadComponent = Array.isArray(uploadRef) ? uploadRef[0] : uploadRef;
                    if (uploadComponent && typeof uploadComponent.resetAllState === 'function') {
                        uploadComponent.resetAllState(); // 调用上传组件的重置方法
                    }
                    // 重置表单数据中的对应字段
                    this.$set(this.formData, prop, []);
                }
            });

            // 3. 重置表单校验状态
            if (this.$refs.formRef) {
                this.$refs.formRef.clearValidate();
            }
        },

        /**
         * 格式化上传组件的历史文件
         * @param {Object} item 表单项配置
         * @param {Array} value 表单绑定的当前值
         * @returns {Array} 适配上传组件的文件列表
         */
        formatUploadHistoryFiles(item, value) {
            if (!Array.isArray(value) || value.length === 0) return [];

            // 定义常见文件扩展名映射（和上传组件保持一致）
            const extTypeMap = {
                image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico'],
                video: ['mp4', 'avi', 'mov', 'flv', 'wmv', 'mkv', 'webm', 'mpeg'],
                audio: ['mp3', 'wav', 'ogg', 'flac', 'aac', 'wma', 'm4a'],
                document: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'zip', 'rar']
            }

            // 获取自定义字段配置，默认取url
            const customKey = item.uploadField?.name || 'url';

            // 如果是简单数组（字符串数组），转换为上传组件需要的格式
            if (value.every(item => typeof item === 'string')) {
                return value.map(url => {
                    // 从URL中提取文件名和扩展名
                    const fileName = url.split('/').pop() || '未知文件';
                    const extension = fileName.split('.').pop()?.toLowerCase() || '';
                    // 判断类型（和上传组件逻辑一致）
                    let type = 'document';
                    if (extTypeMap.image.includes(extension)) {
                        type = 'image';
                    } else if (extTypeMap.video.includes(extension)) {
                        type = 'video';
                    } else if (extTypeMap.audio.includes(extension)) {
                        type = 'audio';
                    } else if (extTypeMap.document.includes(extension)) {
                        type = 'document';
                    }
                    return {
                        id: `history_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                        url,
                        name: fileName,
                        type: type,
                        mime_type: 'application/octet-stream'
                    };
                });
            }

            // 如果是对象数组，根据自定义字段转换
            return value.map((obj, index) => {
                const url = obj[customKey] || '';
                const fileName = obj.name || url.split('/').pop() || '未知文件';
                const extension = fileName.split('.').pop()?.toLowerCase() || '';
                // 判断类型（和上传组件逻辑一致）
                let type = obj.type || 'document';
                if (!obj.type) { // 如果obj没有type，自动判断
                    if (extTypeMap.image.includes(extension)) {
                        type = 'image';
                    } else if (extTypeMap.video.includes(extension)) {
                        type = 'video';
                    } else if (extTypeMap.audio.includes(extension)) {
                        type = 'audio';
                    } else if (extTypeMap.document.includes(extension)) {
                        type = 'document';
                    }
                }
                return {
                    id: obj.id || `history_${Date.now()}_${index}_${Math.random().toString(36).substr(2, 9)}`,
                    url,
                    name: fileName,
                    type: type,
                    mime_type: obj.mime_type || 'application/octet-stream',
                    ...obj
                };
            });
        },

        /**
         * 处理上传成功事件
         * @param {Object} item 表单项配置
         * @param {Array} files 上传组件返回的完整文件列表
         */
        handleUploadSuccess(item, files) {
            if (!Array.isArray(files) || files.length === 0) return;

            const prop = item.prop;
            const customKey = item.uploadField?.name;

            let formattedValue = [];

            if (customKey) {
                // 自定义字段模式：对象数组
                formattedValue = files.map(file => ({
                    [customKey]: file.url,
                    id: file.id,
                    name: file.name,
                    type: file.type,
                    mime_type: file.mime_type,
                    extension: file.extension
                }));
            } else {
                // 默认模式：URL字符串数组
                formattedValue = files.map(file => file.url || '');
            }

            // 强制响应式更新
            this.$set(this.formData, prop, formattedValue);
            this.handleItemChange(prop, formattedValue);
        },

        /**
         * 表单项显隐判断
         * @param {Object} item 表单项配置
         * @returns {Boolean} 是否显示
         */
        isItemShow(item) {
            if (!item.showCondition) return true;
            return typeof item.showCondition === 'function'
                ? item.showCondition({ ...this.formData }, this.dialogType)
                : true;
        },

        /**
         * 表单项禁用判断（优先级：自定义禁用规则 > 场景禁用 > 整体禁用）
         * @param {Object} item 表单项配置
         * @returns {Boolean} 是否禁用
         */
        getItemDisabledStatus(item) {
            // 1. 自定义禁用规则
            if (item.disabledCondition) {
                return typeof item.disabledCondition === 'function'
                    ? item.disabledCondition({ ...this.formData }, this.dialogType)
                    : false;
            }
            // 2. 场景禁用（新增/编辑）
            if (this.dialogType === 'edit' && item.disabledInEdit) return true;
            if (this.dialogType === 'add' && item.disabledInAdd) return true;
            // 3. 整体禁用
            return this.formDisabled;
        },

        /**
         * 确认提交（带表单校验）
         */
        handleConfirm() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    this.$emit('confirm', {
                        data: { ...this.formData },
                        type: this.dialogType
                    });
                    // 提交成功后重置上传组件（新增场景）
                    // this.resetAllUploadComponents();
                } else {
                    this.$message.error('请检查表单数据');
                }
            });
        },

        /**
         * 取消操作（重置上传组件 + 关闭弹窗）
         */
        handleCancel() {
            // 1. 重置所有上传组件
            this.resetAllUploadComponents();
            // 2. 触发取消事件
            this.$emit('cancel', { type: this.dialogType });
            // 3. 关闭弹窗
            this.localDialogVisible = false;
            this.$emit('update:dialogVisible', false);
        },

        /**
         * 弹窗关闭事件（确保关闭时重置状态）
         */
        handleDialogClose() {
            this.resetAllUploadComponents();
            this.handleCancel();
        },

        /**
         * 表单项输入事件（输入框/文本域专用）
         * @param {String} prop 字段名
         * @param {Any} value 输入值
         */
        handleItemInput(prop, value) {
            this.$emit('item-input', { prop, value, type: this.dialogType });
        },

        /**
         * 表单项变更事件（通用）
         * @param {String} prop 字段名
         * @param {Any} value 新值
         */
        handleItemChange(prop, value) {
            this.$emit('item-change', { prop, value, type: this.dialogType });
        },

        /**
         * 表单项清空事件
         * @param {String} prop 字段名
         */
        handleItemClear(prop) {
            this.$emit('item-clear', { prop, type: this.dialogType });
        },

        /**
         * 表单项失焦事件
         * @param {String} prop 字段名
         * @param {Event} event 事件对象
         */
        handleItemBlur(prop, event) {
            this.$emit('item-blur', { prop, event, type: this.dialogType });
        },

        /**
         * 对外暴露：表单校验方法
         * @param {Function} cb 校验回调函数
         */
        validateForm(cb) {
            if (this.$refs.formRef) {
                this.$refs.formRef.validate(cb);
            }
        },

        /**
         * 对外暴露：重置表单方法（含上传组件）
         */
        resetForm() {
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
            // 重置上传组件
            this.resetAllUploadComponents();
        }
    }
};
</script>

<style scoped>
/* 弹窗整体样式 */
::v-deep .el-dialog__title {
    font-weight: 800 !important;
}

::v-deep .el-dialog__header {
    background-color: #EFF5FF !important;
}

::v-deep .el-dialog {
    border-radius: 20px !important;
    overflow: hidden !important;
}

::v-deep .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #f5f5f5;
}

::v-deep .el-dialog__title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

::v-deep .el-dialog__headerbtn {
    top: 18px;
}

::v-deep .el-dialog__body {
    padding: 0;
}

/* 表单容器样式 */
.custom-form {
    padding: 20px;
    max-height: calc(100vh - 180px);
    overflow-y: auto;
}

.form-item-col {
    margin-bottom: 16px;
}

/* 表单项样式重置 */
::v-deep .el-form-item {
    margin-bottom: 0;
}

::v-deep .el-form-item__label {
    font-size: 14px;
    color: #666;
}

::v-deep .el-input__inner,
::v-deep .el-select__wrapper,
::v-deep .el-textarea__inner {
    border-radius: 4px;
    border-color: #e0e0e0;
}

::v-deep .el-input__inner:focus,
::v-deep .el-select__wrapper:focus-within,
::v-deep .el-textarea__inner:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 弹窗底部样式 */
::v-deep .el-dialog__footer {
    padding: 12px 20px;
    border-top: 1px solid #f5f5f5;
    text-align: right;
    background-color: #F9FAFB;
}

.dialog-footer-btn {
    min-width: 80px;
    margin-left: 12px;
}

.confirm-btn {
    background-color: #1890ff;
    border-color: #1890ff;
}

/* 表单滚动条样式 */
.custom-form::-webkit-scrollbar {
    width: 6px;
}

.custom-form::-webkit-scrollbar-thumb {
    background-color: #dcdcdc;
    border-radius: 3px;
}

.custom-form::-webkit-scrollbar-track {
    background-color: #f5f5f5;
}
</style>